<template>
  <div class="container">
    <transition :name="runnerTransition" mode="out-in">
      <div v-if="mode === 'Runner'" class="runner-container" :key="'runner-view'">
        <transition name="fade">
          <img v-if="canGoBack" src="~@/assets/icons/return.svg" alt="close" class="back-btn" @click="back" />
        </transition>

        <div class="spacer--xl"/>
        <transition :name="runnerTransition" mode="out-in">
          <SelfServiceVettingRunnerNode
            v-if="isNodeReady"
            :key="currentNode.id"
            :node="currentNode"
            @capture="capture"
            @setProjectProperty="setProjectProperty"
          />
        </transition>
      </div>
      <div v-else-if="mode === 'Summary'" class="summary-container" :key="'summary-view'">
        <span class="text--xl text--bold">Summary</span>
        <div class="spacer--l" />
        <table class="summary-table">
          <tbody>
          <tr v-for="response of runner.getSummary()" :key="response.node.id">
            <td class="label-cell">
              <span class="text--m">{{response.node.label}}</span>
            </td>
            <td class="description-cell">
              <span class="text--m text--bold ml-4">{{response.valueDescription}}</span>
            </td>
            <td class="edit-cell">
              <img src="~@/assets/icons/edit_black.svg" class="edit-icon" @click="editResponse(response)" />
            </td>
          </tr>
          </tbody>
        </table>
        <div class="spacer--l" />
        <span class="text--l">Is this correct?</span>
        <div class="spacer--l" />
        <a-btn @click="submit">Yeah, looks good</a-btn>
        <div class="spacer--m" />
      </div>
    </transition>
  </div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn.vue";
import SelfServiceVettingRunnerNode from "@/components/SelfService/SelfServiceVettingRunnerNode.vue";

export default {
  components: {SelfServiceVettingRunnerNode, ABtn},
  props: ['runner'],
  data() {
    return {
      mode: 'Runner',
      currentNode: this.runner.currentNode,
      isBackwardNavigation: null,
    }
  },
  created() {
    this.runner.start()
    this.runner.onComplete(this.onComplete);
  },
  watch: {
    'runner.currentNode': {
      handler(newVal) {
        if (newVal) {
          this.currentNode = newVal;
        }
      },
      immediate: true,
    },
  },
  methods: {
    capture(nodeId, value) {
      this.isBackwardNavigation = false;
      this.runner.capture(nodeId, value);
    },
    back() {
      this.isBackwardNavigation = true;
      this.runner.back();
    },
    onComplete() {
      this.mode = 'Summary'
    },
    editResponse(response){
      this.isBackwardNavigation = true;
      this.runner.resume(response.node.id);
      this.mode = 'Runner';
    },
    submit(){
      this.$emit('complete')
    },
    setProjectProperty(event) {
      this.$emit('setProjectProperty', event)
    }
  },
  computed: {
    isNodeReady() {
      return this.currentNode !== null;
    },
    canGoBack() {
      return this.runner.canBack();
    },
    runnerTransition() {
      return this.isBackwardNavigation ? 'slide-fade-reverse' : 'slide-fade';
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  //display: flex;
  //flex-direction: column;
  flex-grow: 1;

  .runner-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    //align-content: center;
    //align-items: center;
    position: relative;
  }

  .summary-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .summary-table {
      width: 100%;
      border-collapse: collapse;

      tbody {
        tr {
          border-bottom: 1px solid #f0f0f0;
        }

        tr:not(:last-child) {
          margin-bottom: 1em;
        }

        td {
          padding: 0.5em;

          &.label-cell {
            width: 70%;
          }

          &.description-cell {
            width: 25%;
          }

          &.edit-cell {
            width: 5%;
            text-align: right;

            .edit-icon {
              cursor: pointer;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
}

.back-btn {
  position: absolute;
  left: -40px;
  top: 70px;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
}

// forward navigation transition
.slide-fade-enter-active {
  transition: opacity 0.3s, transform 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s ease-in;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateY(200%);
}
.slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(-200%);
}

// backwards navigation transition
.slide-fade-reverse-enter-active {
  transition: opacity 0.3s, transform 0.3s ease-out;
}
.slide-fade-reverse-leave-active {
  transition: opacity 0.3s, transform 0.3s ease-in;
}
.slide-fade-reverse-enter {
  opacity: 0;
  transform: translateY(-200%);
}
.slide-fade-reverse-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(200%);
}

// fade transition
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.fade-in {
  opacity: 1;
  animation-name: fadeInOpacity;
  //animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
